import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {spotInvalidWalletData$, spotWalletData$} from './spot-wallets';
import {spotPTDiscountState$} from './spot-user';
import type {SpotWalletsData} from '@/types';

export interface USpotWallets {
  type: 'spot-wallets' | 'spot-invalid-wallets';
  data: SpotWalletsData;
}

export interface USpotPTDiscountState {
  type: 'spot-pt-discount-state';
  data: {state: boolean};
}

export function subscribeSpotWallet() {
  spotWalletData$
    .pipe(map((walletData: SpotWalletsData): USpotWallets => ({type: 'spot-wallets', data: walletData})))
    .subscribe((msg) => toUiMsg$.next(msg));

  spotInvalidWalletData$
    .pipe(map((walletData: SpotWalletsData): USpotWallets => ({type: 'spot-invalid-wallets', data: walletData})))
    .subscribe((msg) => toUiMsg$.next(msg));
}

export function subscribeSpotPtState() {
  spotPTDiscountState$
    .pipe(map((state: boolean): USpotPTDiscountState => ({type: 'spot-pt-discount-state', data: {state}})))
    .subscribe((msg) => toUiMsg$.next(msg));
}
